export default __webpack_public_path__ + "static/iconography-image-g-1804c16a9c7d0a2ab0072e4fe5220acf.png";